import { BCMSRecord, Workflow, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import SettingsFastBalancesPage from "components/pages/SettingsFastBalancesPage";
import Classes, { Account, FastBalanceMobileDevice } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <SettingsFastBalancesPage /> ];

/**
 * @function SettingsFastBalancesWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the Fast Balances page.
 * 
 * Setting constructor example for state captures:
 * 
 * document.dispatchEvent(new CustomEvent("force-workflow-state", {
  detail: { 
    value: { 
      mobileDevices: [
        { id: "0", name: "some device name 0"},
        { id: "1", name: "some device name 1"},
        { id: "2", name: "some device name 2"}
      ],
      accounts: [
        { id: "0", name: "some account name 0", number: "some account number 0" },
        { id: "1", name: "some account name 1", number: "some account number 1" },
        { id: "2", name: "some account name 2", number: "some account number 2" }
      ]
    } 
  } 
}));
 */
export default function SettingsFastBalancesWorkflow(props) {
    const context = useBCMSContext();
    const { user } = useModel();
    // Get the inital state of the workflow
    BCMSRecord.globalControllerFor(Classes, context);
    const value = getDefault(user);

    // Define the constructor function for forcing state through the 'force-workflow-state' event
    const constructor = record => {
        // Return the new workflow default object.
        return { 
            
        };
    };

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } constructor={ constructor } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = (user, mobileDevice) => {
    const mobileDevices = FastBalanceMobileDevice.initAll();
    const accounts = Account.initAll();
    user = user ?? {};

    return {
        accounts, 
        mobileDevices,
        // "George's Iphone" from the model is shown
        // by default unless another device is passed.
        mobileDevice: mobileDevice ? mobileDevice : mobileDevices[0],
        user,
    }
};